<template>
  <div>
    <v-layout wrap>
      <v-flex xs9><Typography h4 bold :label="$t(`Setting the bot's on-off time`)" /> </v-flex>
      <v-flex xs3 class="text-xs-right">
        <div v-if="!isEdit" @click="isEdit = true">
          <img
            src="/static/img/TooltipEdit.png"
            alt
            class="responsive-img mb-1 pointer"
            style="height: 22px"
          />
        </div>
        <div v-if="isEdit" @click="onSaveTimeTable">
          <img
            src="/static/img/editConfirm.png"
            alt
            class="responsive-img mb-1 pointer"
            style="height: 22px"
          />
        </div>
      </v-flex>
    </v-layout>
    <template v-for="(time, key) in timetable">
      <open-time-bot-item
        :key="key"
        v-model="timetable[key]"
        :name="key"
        :isEdit="isEdit"
      ></open-time-bot-item>
    </template>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import OpenTimeBotItem from './OpenTimeBotItem'
import Typography from '@/components/elements/Typography.vue'

export default {
  data() {
    return {
      isEdit: false,
      timetable: {
        Monday: { status: true, openat: null, closeat: null },
        Tuesday: { status: true, openat: null, closeat: null },
        Wednesday: { status: true, openat: null, closeat: null },
        Thursday: { status: true, openat: null, closeat: null },
        Friday: { status: true, openat: null, closeat: null },
        Saturday: { status: true, openat: null, closeat: null },
        Sunday: { status: true, openat: null, closeat: null },
      },
    }
  },
  components: {
    OpenTimeBotItem,
    Typography,
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
    }),
  },
  mounted() {
    this.getTimeToUseBot()
  },
  methods: {
    getTimeToUseBot: function () {
      var vm = this
      return new Promise((resolve, reject) => {
        api.getTimeToUseBot({ pageid: this.selectedBot.pageid }, function (error, response) {
          if (error) {
            reject(error)
          }
          if (response.data) {
            if (response.data.timetousebot) {
              if (response.data.timetousebot) {
                vm.timetable = JSON.parse(response.data.timetousebot)
              } else {
                vm.timetable = {
                  Monday: { status: true, openat: null, closeat: null },
                  Tuesday: { status: true, openat: null, closeat: null },
                  Wednesday: { status: true, openat: null, closeat: null },
                  Thursday: { status: true, openat: null, closeat: null },
                  Friday: { status: true, openat: null, closeat: null },
                  Saturday: { status: true, openat: null, closeat: null },
                  Sunday: { status: true, openat: null, closeat: null },
                }
              }

              vm.cached_timetable = JSON.stringify(vm.timetable)
            }
            vm.cached_timetable = JSON.stringify(vm.timetable)
          }
          resolve()
        })
      })
    },
    onCancelTimeTable: function () {
      var vm = this
      vm.timetable = JSON.parse(vm.cached_timetable)
      vm.isEdit = false
    },
    onSaveTimeTable: function () {
      var vm = this
      vm.$store.dispatch('loading')
      return new Promise((resolve, reject) => {
        vm.$validator.validateAll().then((result) => {
          if (!result) {
            // do stuff if not valid.
            vm.goToErrorInput()
            reject()
            return false
          }
          var data = {
            timetousebot: JSON.stringify(vm.timetable),
            pageid: this.selectedBot.pageid,
          }
          console.log(vm.timetable)
          api.saveTimeToUseBot(data, function (error, response) {
            if (error) {
              reject(error)
              vm.$store.dispatch('loading')
            }
            vm.cached_timetable = JSON.stringify(vm.timetable)
            vm.isEdit = false
            vm.$store.dispatch('loading')
            resolve()
          })
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/billing/ManageOpenTimeBot.vue